import React, { useState } from 'react'
import { COLORS } from 'app/constants'
import { useTranslation } from 'react-i18next'
import { Text } from 'styles/reactnative'
import { VerfiyHeader, VerifyContainer, VerifyWrapper } from './styles'
import VerifyCode from './VerifyCode'

const VerifySection = ({ authSuccess, setAuthSuccess }) => {
	const { t } = useTranslation()
	const [verifyError, setVerifyError] = useState()
	return (
		<VerifyContainer>
			<VerifyWrapper>
				<VerfiyHeader>
					<Text
						size={24}
						style={{
							fontWeight: 'bold',
							color: COLORS.black,
							letterSpacing: 0.5,
						}}>
						{t('authentication')}
					</Text>
				</VerfiyHeader>
				<VerfiyHeader style={{ marginBlock: 15 }}>
					<Text
						size={16}
						style={{
							fontWeight: '300',
							color: COLORS.black,
							lineHeight: 1.3,
						}}>
						{t('pleaseEnterTheVerificationCode')}
					</Text>
				</VerfiyHeader>
				{verifyError ? (
					<Text
						style={{
							fontSize: 12,
							fontWeight: '300',
							color: COLORS.lightRed,
							lineHeight: 1.3,
						}}>
						{t('verificationCodeError')}
					</Text>
				) : null}
				<VerifyCode
					authSuccess={authSuccess}
					setAuthSuccess={setAuthSuccess}
					setVerifyError={setVerifyError}
				/>
				<VerfiyHeader style={{ marginBlock: 15 }}>
					<Text
						size={14}
						style={{
							color: COLORS.BTN_HOVER,
							fontWeight: '500',
						}}>
						{t('havingProblemsWithVerification')}
					</Text>
				</VerfiyHeader>
			</VerifyWrapper>
		</VerifyContainer>
	)
}

export default VerifySection
